import React, { useEffect, useState } from "react";
import axios from "axios";
import { all_routes } from "../../router/all_routes";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DatePicker } from "antd";
import CommonSelect from "../../../core/common/addEmployeecommonselect";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useDepartment from "../../../core/api/useDepartment";
import useDesignations from "../../../core/api/useDesignations";
import { useRoles, getRolesList } from "../../../core/api/useRoles";
import useCreateEmployee from "../../../core/api/useCreateEmployee";
import { jobTypeOptions } from "../../../core/hardcoded/jobTypes";
import dayjs from "dayjs";
import useDeleteEmployee from "../../../core/api/useDeleteEmployee";
import { API_BASE_PATH } from "../../../environment";
import { toast } from "react-toastify";
import {
  getAllProjects,
  ProjectAPIResponse,
} from "../../../core/api/useProject";
import useEmpDetails from "../../../core/api/useEmpdetail";
import { useAuthToken } from "../../../core/data/redux/useAuthToken";

type PasswordField = "password" | "confirmPassword";

type Employee = {
  key: string;
  EmpId: string;
  Name: string;
  Email: string;
  Phone: string;
  Designation: string;
  JoiningDate: string;
  Status: string;
  Image: string;
  CurrentRole: string;
  employee_status?: string; // ✅ for stats
  join_date?: string; // ✅ for stats
  inProgress?: string; // ✅ for stats
  done?: string; // ✅ for stats
  projects?: string; // ✅ for stats
  productivity?: string; // ✅ for stats
};

type Department = {
  department_name: string;
  employee_count?: number;
  status?: string;
};

type Designation = {
  designation: string;
  department: string;
  totalEmployees?: number;
  status?: string;
  createdAt?: string;
};

type Role = {
  role_name: string;
  status?: string;
};

type EmployeeFormType = {
  firstname: string;
  lastName: string;
  employeeId: string;
  joiningDate: string;
  username: string;
  email: string;
  password: string;
  phone: string;
  company: string;
  role: string;
  department: string;
  designation: string;
  jobType: string;
  image: File | null;
  imagePreview: string;
};

type SelectOption = {
  label: string;
  value: string;
};

type SelectProps = {
  className?: string;
  options: SelectOption[];
  value: SelectOption; // ✅ This is what's missing
  onChange: (selected: SelectOption) => void;
};

const EmployeesGrid = () => {
  const BASE_PATH = API_BASE_PATH;
  const { createEmployee, isLoading: isCreating } = useCreateEmployee();
  const { deleteEmployee } = useDeleteEmployee();
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const navigate = useNavigate();
  const [employeeForm, setEmployeeForm] = useState<EmployeeFormType>({
    firstname: "",
    lastName: "",
    employeeId: "",
    joiningDate: "",
    username: "",
    email: "",
    password: "",
    phone: "",
    company: "",
    role: "",
    department: "",
    designation: "",
    jobType: "",
    image: null,
    imagePreview: "",
  });
  const [imageError, setImageError] = useState<string>("");
  const [nameErrors, setNameErrors] = useState<Record<string, string>>({});
  const empToken = useAuthToken();
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const maxSize = 4 * 1024 * 1024; // 4MB
      if (file.size > maxSize) {
        setImageError("Image size should be less than 4MB.");

        // Reset the input value so the same file can trigger onChange again
        e.target.value = "";
        return;
      }

      setImageError(""); // Clear previous error
      setEmployeeForm((prev) => ({
        ...prev,
        image: file,
        imagePreview: URL.createObjectURL(file),
      }));
    }

    // Optional: reset input for other edge cases
    e.target.value = "";
  };

  let handleSubmit = async () => {
    if (
      !employeeForm.firstname ||
      !employeeForm.email ||
      !employeeForm.password ||
      !employeeForm.username ||
      !employeeForm.employeeId ||
      !employeeForm.joiningDate
    ) {
      toast.warning("Please fill all required fields.");
      return;
    }
    let formData = new FormData();
    formData.append("firstname", employeeForm.firstname);
    formData.append("lastname", employeeForm.lastName);
    formData.append("employee_id", employeeForm.employeeId);
    formData.append("join_date", "2025-02-24");
    formData.append("username", employeeForm.username);
    formData.append("email", employeeForm.email);
    formData.append("password", employeeForm.password);
    formData.append("phone", employeeForm.phone);
    formData.append("company", employeeForm.company);
    formData.append("role_name", employeeForm.role);
    formData.append("department_name", employeeForm.department);
    formData.append("designation_name", employeeForm.designation);
    formData.append("job_type_name", employeeForm.jobType);

    if (employeeForm.image) {
      formData.append("photo", employeeForm.image);
    }
    try {
      await createEmployee(formData, fetchEmployees, empToken); // ✅ this auto refreshes the table
      setEmployeeForm({
        firstname: "",
        lastName: "",
        employeeId: "",
        joiningDate: "",
        username: "",
        email: "",
        password: "",
        phone: "",
        company: "",
        role: "",
        department: "",
        designation: "",
        jobType: "",
        image: null,
        imagePreview: "",
      });
      setShowAddModal(false);
    } catch (error) {
      console.error("Error creating employee:", error);
    }
  };

  {
    /*  Employe Create Part   */
  }
  const { getNormalizedDepartments } = useDepartment(empToken);
  const { fetchDesignationsAllInfo } = useDesignations(empToken);
  const { roles, fetchRoles } = useRoles(); // ✅ Hook usage

  const [department, setDepartment] = useState<
    { value: string; label: string }[]
  >([{ value: "Select", label: "Select" }]);
  const [designation, setDesignation] = useState<
    { value: string; label: string }[]
  >([{ value: "Select", label: "Select" }]);
  const [roleName, setRoleName] = useState<{ value: string; label: string }[]>([
    { value: "Select", label: "Select" },
  ]);

  const [jobType, setJobType] = useState(jobTypeOptions);

  const [employees, setEmployees] = useState<Employee[]>([]);
  const [tableKey, setTableKey] = useState<number>(0);

  const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(
    null
  );

  const BASE_URL = API_BASE_PATH;
  const fetchEmployees = async (_token?: string | null) => {
    try {
      const res = await axios.get(`${BASE_URL}/register/admin/all`, {
        headers: {
          Accept: "application/json",
          Authorization: _token ? `Bearer ${_token}` : "", // ✅ Added Bearer token
        },
      });

      const raw = res.data;
      const totalEmployees = raw.length;
      const activeEmployees = raw.filter(
        (e: any) => e.employee_status === "Active"
      ).length;
      const inactiveEmployees = raw.filter(
        (e: any) => e.employee_status !== "Active"
      ).length;

      const newJoiners = raw.filter((e: any) => {
        if (!e.join_date) return false;
        const joinDate = new Date(e.join_date);
        const now = new Date();
        const daysAgo30 = new Date(now.setDate(now.getDate() - 30));
        return joinDate >= daysAgo30;
      }).length;

      const transformed = raw.map(
        (emp: any): Employee => ({
          key: emp.employee_id,
          EmpId: emp.employee_id,
          Name: `${emp.firstname} ${emp.lastname}`,
          Email: emp.email,
          Phone: emp.phone,
          Designation:
            emp.designation_name ||
            emp.designation_data?.designation_name ||
            "-",
          JoiningDate: emp.join_date,
          Status: emp.employee_status || "Active",
          Image: emp.photo || "default.jpg",
          CurrentRole: emp.role_name || emp.role_data?.role_name || "-",
        })
      );

      setEmployees(transformed);
      setTableKey((prev) => prev + 1);
    } catch (err) {
      console.error("Failed to fetch employees:", err);
    }
  };

   useEffect(() => {
    fetchEmployees(empToken);
  }, []);


  const columns = [
    {
      title: "Emp ID",
      dataIndex: "EmpId",
      render: (text: string, record: Employee) => (
        <Link to={all_routes.employeedetails} state={{ employee: record }}>
          {text}
        </Link>
      ),
      sorter: (a: Employee, b: Employee) => a.EmpId.localeCompare(b.EmpId),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: string, record: Employee) => (
        <div className="d-flex align-items-center">
          <Link
            to={all_routes.employeedetails}
            state={{ employee: record }}
            className="avatar avatar-md"
          >
            <img
              src={`${BASE_PATH}/register/employee/${record.EmpId}/image`}
              className="img-fluid rounded-circle"
              alt="/assets/img/defaultavatar.png"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.onerror = null;
                target.src = "/assets/img/defaultavatar.png";
              }}
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link
                to={all_routes.employeedetails}
                state={{ employee: record }}
              >
                {record.Name}
              </Link>
            </p>
            <span className="fs-12">{record.CurrentRole}</span>
          </div>
        </div>
      ),
      sorter: (a: Employee, b: Employee) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: Employee, b: Employee) => a.Email.localeCompare(b.Email),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: Employee, b: Employee) => a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Designation",
      dataIndex: "Designation",
      render: (text: string) => (
        <span className="badge bg-secondary text-capitalize">{text}</span>
      ),
      sorter: (a: Employee, b: Employee) =>
        a.Designation.localeCompare(b.Designation),
    },
    {
      title: "Joining Date",
      dataIndex: "JoiningDate",
      sorter: (a: Employee, b: Employee) =>
        new Date(a.JoiningDate).getTime() - new Date(b.JoiningDate).getTime(),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => (
        <span
          className={`badge ${
            text === "Active" ? "badge-success" : "badge-danger"
          } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: Employee, b: Employee) => a.Status.localeCompare(b.Status),
    },
    {
      title: "Actions",
      render: (_: any, record: Employee) => (
        <div className="action-icon d-inline-flex">
          <button
            className="btn btn-outline-light p-1 me-2"
            onClick={() =>
              navigate(all_routes.employeedetails, {
                state: { employee: record },
              })
            }
          >
            <i className="ti ti-edit" />
          </button>

          <button
            className="btn btn-outline-light p-1"
            onClick={() => {
              setSelectedEmployee(record);
              setShowDeleteModal(true);
            }}
          >
            <i className="ti ti-trash" />
          </button>
        </div>
      ),
    },
  ];

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement || document.body;
  };

  // Level-3 scoped cache
  let departmentCache: Department[] | null = null;
  let roleCache: Role[] | null = null;
  let designationCache: Designation[] | null = null;
  useEffect(() => {
    const loadDropdowns = async () => {
      try {
        if (!departmentCache) {
          const fetchedDepartments = await getNormalizedDepartments();
          departmentCache = fetchedDepartments;
        }

        if (departmentCache) {
          const departmentOptions = departmentCache.map((item) => ({
            value: item.department_name,
            label: item.department_name,
          }));
          setDepartment([
            { value: "Select", label: "Select" },
            ...departmentOptions,
          ]);
        }

        // ✅ Roles using getRolesList
        if (!roleCache) {
          const fetchedRoles = await getRolesList(empToken);
          roleCache = fetchedRoles;
        }

        if (roleCache) {
          const roleOptions = roleCache.map((item: Role) => ({
            value: item.role_name,
            label: item.role_name,
          }));
          setRoleName([{ value: "Select", label: "Select" }, ...roleOptions]);
        }

        // ✅ Designations
        if (!designationCache) {
          const fetchedDesignations = await fetchDesignationsAllInfo();
          designationCache = fetchedDesignations;
        }

        if (designationCache) {
          const designationOptions = designationCache.map((item) => ({
            value: item.designation,
            label: item.designation,
          }));
          setDesignation([
            { value: "Select", label: "Select" },
            ...designationOptions,
          ]);
        }
      } catch (error) {
        console.error("Dropdown fetch error:", error);
      }
    };

    loadDropdowns();
  }, []);

  const totalEmployees = employees.length;
  const activeEmployees = employees.filter((e) => e.Status === "Active").length;
  const inactiveEmployees = employees.filter(
    (e) => e.Status !== "Active"
  ).length;

  // Optional: New Joiners in last 30 days
  const newJoiners = employees.filter((e) => {
    if (!e.JoiningDate) return false;
    const joinDate = new Date(e.JoiningDate);
    const now = new Date();
    const daysAgo30 = new Date(now.setDate(now.getDate() - 30));
    return joinDate >= daysAgo30;
  }).length;

  const handleDelete = async () => {
    if (!selectedEmployee?.EmpId) {
      return;
    }

    try {
      await deleteEmployee(selectedEmployee.EmpId, empToken); // ✅ Pass correct ID
      await fetchEmployees(); // ✅ Refresh table
      setSelectedEmployee(null); // Clear selection
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };
  const [projects, setProjects] = useState<ProjectAPIResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const employeeId = location.state?.employee.EmpId || "";
  const { data: empDetails, isLoading, fetchDetails } = useEmpDetails(empToken);
  useEffect(() => {
    if (!employees || employees.length === 0) return;

    const fetchProjects = async () => {
      try {
        const employeeIds = employees.map((emp) => emp.EmpId?.toString());
        const filteredProjects = await getAllProjects(employeeIds);
        setProjects(filteredProjects || []);
      } catch (err) {
        console.error("Error fetching employee projects:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [employees]);

  if (loading) return <div>Loading...</div>;
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Employee</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Employee Grid
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                  <Link
                    to={all_routes.employeeList}
                    className="btn btn-icon btn-sm me-1"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={all_routes.employeeGrid}
                    className="btn btn-icon btn-sm active bg-primary text-white"
                  >
                    <i className="ti ti-layout-grid" />
                  </Link>
                </div>
              </div>
              {/* Export */}
              <div className="mb-2">
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center"
                  onClick={() => setShowAddModal(true)}
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Employee
                </button>
              </div>
              <div className="ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* widgets */}
          <div className="row">
            {/* Total Plans */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-dark rounded-circle">
                        <i className="ti ti-users" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Total Employee
                      </p>
                      <h4>{totalEmployees}</h4>
                    </div>
                  </div>
                  <div>
                    {/* <span className="badge badge-soft-purple badge-sm fw-normal">
                                            <i className="ti ti-arrow-wave-right-down" />
                                            +19.01%
                                        </span> */}
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Plans */}
            {/* Total Plans */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-success rounded-circle">
                        <i className="ti ti-user-share" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Active
                      </p>
                      <h4>{activeEmployees}</h4>
                    </div>
                  </div>
                  <div>
                    {/* <span className="badge badge-soft-primary badge-sm fw-normal">
                                            <i className="ti ti-arrow-wave-right-down" />
                                            +19.01%
                                        </span> */}
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Plans */}
            {/* Inactive Plans */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-danger rounded-circle">
                        <i className="ti ti-user-pause" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        InActive
                      </p>
                      <h4>{inactiveEmployees}</h4>
                    </div>
                  </div>
                  <div>
                    {/* <span className="badge badge-soft-dark badge-sm fw-normal">
                                            <i className="ti ti-arrow-wave-right-down" />
                                            +19.01%
                                        </span> */}
                  </div>
                </div>
              </div>
            </div>
            {/* /Inactive Companies */}
            {/* No of Plans  */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-info rounded-circle">
                        <i className="ti ti-user-plus" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        New Joiners
                      </p>
                      <h4>{newJoiners}</h4>
                    </div>
                  </div>
                  <div>
                    {/* <span className="badge badge-soft-secondary badge-sm fw-normal">
                                            <i className="ti ti-arrow-wave-right-down" />
                                            +19.01%
                                        </span> */}
                  </div>
                </div>
              </div>
            </div>
            {/* /No of Plans */}
          </div>
          <div className="card">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Employees Grid</h5>
                <div className="d-flex align-items-center flex-wrap row-gap-3">
                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Designation
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Finance
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Developer
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Executive
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Sort By : Last 7 Days
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Last 7 Days
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Ascending
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Clients Grid */}
          <div className="row">
            {employees.map((emp) => (
              <div className="col-xl-3 col-lg-4 col-md-6" key={emp.EmpId}>
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div className="form-check form-check-md">
                        <input className="form-check-input" type="checkbox" />
                      </div>
                      <div>
                        <Link
                          to={`${all_routes.employeedetails}?id=${emp.EmpId}`}
                          state={{ employee: emp }}
                          className="avatar avatar-xl avatar-rounded online border p-1 border-primary rounded-circle"
                        >
                          <span>
                            <img
                              src={`${API_BASE_PATH}/register/employee/${emp.EmpId}/image`}
                              className="w-auto h-auto"
                              alt="/assets/img/defaultavatar.png"
                              onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.onerror = null;
                                target.src = "/assets/img/defaultavatar.png";
                              }}
                            />
                          </span>
                        </Link>
                      </div>
                      <div className="dropdown">
                        <button
                          className="btn btn-icon btn-sm rounded-circle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="ti ti-dots-vertical" />
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end p-3">
                          <li>
                            <Link
                              className="dropdown-item rounded-1"
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#edit_employee"
                            >
                              <i className="ti ti-edit me-1" />
                              Edit
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item rounded-1"
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#delete_modal"
                            >
                              <i className="ti ti-trash me-1" />
                              Delete
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="text-center mb-3">
                      <h6 className="mb-1">
                        <Link
                          to={`${all_routes.employeedetails}?id=${emp.EmpId}`}
                          state={{ employee: emp }}
                        >
                          {emp.Name}
                        </Link>
                      </h6>
                      <span className="badge bg-pink-transparent fs-10 fw-medium">
                        {emp.Designation || "N/A"}
                      </span>
                    </div>

                    {/* Project Info */}
                    {/* <div className="row">
                      {projects.map((project) => (
                        <div className="col-md-4" key={project.project_id}>
                          <div className="card">
                            <div className="card-body">
                              <h5>{project.}</h5>
                              <p>{project.description}</p>
                              <p><strong>Status:</strong> {project.status}</p>
                              <p><strong>Deadline:</strong> {project.deadline}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div> */}

                    {/* Basic Info */}
                    <div
                      className="mb-2 d-grid"
                      style={{ wordBreak: "break-word", minHeight: "150px" }}
                    >
                      <p className="mb-1">
                        <strong>Department:</strong> {emp.CurrentRole || "N/A"}
                      </p>
                      <p className="mb-1">
                        <strong>Status:</strong> {emp.Status}
                      </p>
                      <p className="mb-1">
                        <strong>Email:</strong> {emp.Email}
                      </p>
                      <p className="mb-1">
                        <strong>Phone:</strong> {emp.Phone}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div className="col-md-12">
              <div className="text-center mb-4">
                <Link to="#" className="btn btn-primary">
                  <i className="ti ti-loader-3 me-1" />
                  Load More
                </Link>
              </div>
            </div>
          </div>
          {/* /Clients Grid */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025 © IATT.</p>
          <p>
            Designed &amp; Developed By{" "}
            <Link to="#" className="text-primary">
              IATT
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Employee */}
      {showAddModal && (
        <>
          <div className="modal fade show d-block" role="dialog" tabIndex={-1}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="d-flex align-items-center">
                    <h4 className="modal-title me-2">Add New Employee</h4>
                  </div>
                  <button
                    type="button"
                    className="btn-close custom-btn-close"
                    onClick={() => setShowAddModal(false)}
                    aria-label="Close"
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>

                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="contact-grids-tab">
                    <ul className="nav nav-underline" id="myTab" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="info-tab"
                          type="button"
                          role="tab"
                        >
                          Basic Information
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="basic-info"
                      role="tabpanel"
                      aria-labelledby="info-tab"
                      tabIndex={0}
                    >
                      <div className="modal-body pb-0">
                        <div className="row">
                          {/* 🔽 Image Upload with Preview */}
                          <div className="col-md-12">
                            <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                              <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                                {employeeForm.imagePreview ? (
                                  <img
                                    src={employeeForm.imagePreview}
                                    alt="Preview"
                                    className="img-fluid rounded-circle"
                                    style={{
                                      width: "80px",
                                      height: "80px",
                                      objectFit: "cover",
                                    }}
                                  />
                                ) : (
                                  <i className="ti ti-photo text-gray-2 fs-16" />
                                )}
                              </div>
                              <div className="profile-upload">
                                <div className="mb-2">
                                  <h6 className="mb-1">Upload Profile Image</h6>
                                  <p className="fs-12">
                                    Image should be below 4 mb
                                  </p>
                                </div>
                                <div className="profile-uploader d-flex align-items-center">
                                  <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                    Upload
                                    <input
                                      type="file"
                                      className="form-control image-sign"
                                      accept="image/*"
                                      onChange={handleImageChange}
                                    />
                                  </div>
                                  <Link to="#" className="btn btn-light btn-sm">
                                    Cancel
                                  </Link>
                                </div>
                                {imageError && (
                                  <p className="text-danger mt-2 mb-0 fs-12">
                                    {imageError}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* 🔽 Controlled Input Fields */}
                          {[
                            {
                              label: "First Name",
                              required: true,
                              name: "firstname",
                            },
                            {
                              label: "Last Name",
                              required: false,
                              name: "lastName",
                            },
                            {
                              label: "Employee ID",
                              required: true,
                              name: "employeeId",
                            },
                            {
                              label: "Username",
                              required: true,
                              name: "username",
                            },
                            {
                              label: "Email",
                              required: true,
                              name: "email",
                              type: "email",
                            },
                            {
                              label: "Phone Number",
                              required: true,
                              name: "phone",
                            },
                            {
                              label: "Company",
                              required: true,
                              name: "company",
                            },
                          ].map((field, index) => (
                            <div className="col-md-6" key={index}>
                              <div className="mb-3">
                                <label className="form-label">
                                  {field.label}
                                  {field.required && (
                                    <span className="text-danger"> *</span>
                                  )}
                                </label>
                                <input
                                  type={field.type || "text"}
                                  className="form-control"
                                  value={(employeeForm as any)[field.name]}
                                  onChange={(e) => {
                                    const { value } = e.target;
                                    let error = "";

                                    // First/Last Name: No numbers (but allow empty)
                                    if (
                                      field.name === "firstname" ||
                                      field.name === "lastName"
                                    ) {
                                      if (value && /\d/.test(value)) {
                                        error = "Names cannot contain numbers";
                                      }
                                    }

                                    // Phone: Only digits, 10–12 characters (but allow empty)
                                    if (field.name === "phone") {
                                      if (value && !/^\d{10,12}$/.test(value)) {
                                        error =
                                          "Phone must be 10–12 digits and only contain numbers";
                                      }
                                    }

                                    // Email: Basic format check (but allow empty)
                                    if (field.name === "email") {
                                      const emailRegex =
                                        /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
                                      if (value && !emailRegex.test(value)) {
                                        error =
                                          "Please enter a valid email address";
                                      }
                                    }

                                    // Update error state
                                    setNameErrors((prev) => ({
                                      ...prev,
                                      [field.name]: error,
                                    }));

                                    // Update form state
                                    setEmployeeForm((prev) => ({
                                      ...prev,
                                      [field.name]: value,
                                    }));
                                  }}
                                />
                                {(field.name === "firstname" ||
                                  field.name === "lastName" ||
                                  field.name === "username" ||
                                  field.name === "phone" ||
                                  field.name === "email") &&
                                  nameErrors[field.name] && (
                                    <small className="text-danger">
                                      {nameErrors[field.name]}
                                    </small>
                                  )}
                              </div>
                            </div>
                          ))}

                          {/* 🔽 Password */}
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Password <span className="text-danger"> *</span>
                              </label>
                              <div className="pass-group">
                                <input
                                  type="text"
                                  className="pass-input form-control"
                                  value={employeeForm.password}
                                  onChange={(e) =>
                                    setEmployeeForm((prev) => ({
                                      ...prev,
                                      password: e.target.value,
                                    }))
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          {/* 🔽 Joining Date */}
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Joining Date{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="YYYY-MM-DD"
                                  value={
                                    employeeForm.joiningDate
                                      ? dayjs(
                                          employeeForm.joiningDate,
                                          "YYYY-MM-DD"
                                        )
                                      : null
                                  }
                                  onChange={(date) =>
                                    setEmployeeForm((prev) => ({
                                      ...prev,
                                      joiningDate: date
                                        ? dayjs(date).format("YYYY-MM-DD")
                                        : "",
                                    }))
                                  }
                                  getPopupContainer={getModalContainer}
                                  placeholder="YYYY-MM-DD"
                                />
                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* 🔽 Dropdown Selects */}
                          {[
                            { label: "Role", options: roleName, field: "role" },
                            {
                              label: "Department",
                              options: department,
                              field: "department",
                            },
                            {
                              label: "Designation",
                              options: designation,
                              field: "designation",
                            },
                            {
                              label: "Job Type",
                              options: jobType,
                              field: "jobType",
                            },
                          ].map((item, i) => {
                            const defaultOption = item.options.find(
                              (opt) =>
                                opt.value ===
                                employeeForm[
                                  item.field as keyof EmployeeFormType
                                ]
                            ) || { value: "", label: "Select" };
                            return (
                              <div className="col-md-6" key={i}>
                                <div className="mb-3">
                                  <label className="form-label">
                                    {item.label}
                                  </label>
                                  <CommonSelect
                                    className="select"
                                    options={item.options}
                                    value={
                                      item.options.find(
                                        (opt) =>
                                          opt.value ===
                                          employeeForm[
                                            item.field as keyof EmployeeFormType
                                          ]
                                      ) || { value: "", label: "Select" }
                                    }
                                    onChange={(selected) =>
                                      setEmployeeForm((prev) => ({
                                        ...prev,
                                        [item.field]: selected?.value || "",
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      {/* 🔽 Modal Footer */}
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-outline-light border me-2"
                          onClick={() => setShowAddModal(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSubmit}
                          disabled={isCreating}
                        >
                          {isCreating ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* 🔽 Backdrop */}
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowAddModal(false)}
          />
        </>
      )}
      {showDeleteModal && (
        <>
          <div className="modal fade show d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <p>
                    Are you sure you want to delete{" "}
                    <strong>{selectedEmployee?.Name}</strong>?
                  </p>
                  <div className="d-flex justify-content-center">
                    <button
                      className="btn btn-light me-2"
                      onClick={() => setShowDeleteModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={async () => {
                        await handleDelete();
                        setShowDeleteModal(false);
                      }}
                    >
                      Yes, Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowDeleteModal(false)}
          />
        </>
      )}
    </>
  );
};

export default EmployeesGrid;
